import { graphql } from '@/generated/gql';

export const CONVERSATION_QUERY = graphql(/* GraphQL */ `
  query Conversation($entityId: UUID!, $entityVariant: SvbrgConversationEntityVariant!, $description: String) {
    sevenbridges {
      conversation(id: $entityId, variant: $entityVariant, description: $description) {
        id
        conversationSettings {
          id
          createdAt
          updatedAt
          quickActions {
            id
            prompt
            isConversationStarter
            translations {
              id
              language
              text
              variant
            }
          }
        }
        conversationMessages {
          id
          role
          content
          parts
          metadata
          createdAt
        }
      }
    }
  }
`);
